import { fromJS } from 'immutable';
import getRootState from './rootStateSelector';

export const getWalletState = (state) => {
  return getRootState(state).get('wallet') || fromJS({ wallet: [] });
};

export const getUserWallet = (state) => {
  const walletState = getWalletState(state);
  const wallet = walletState?.wallet;
  return wallet;
};

export const getWalletIsLoading = (state) => {
  const walletState = getWalletState(state);
  return walletState.isLoading;
};

export const getSelectedProduct = (state) => {
  const walletState = getWalletState(state);
  return walletState.selectedProduct;
};

export const getWalletError = (state) => {
  const walletState = getWalletState(state);
  return walletState.error;
};

export const getWalletIsRedirecting = (state) => {
  const walletState = getWalletState(state);
  return walletState.isRedirecting;
};
